<div>
    <fa-icon [icon]="['fas','id-card']" (click)="getEID()"></fa-icon>
</div>